import MasterCrudPage from "../../components/MasterCrudPage";
import { assetSourceLocationApi } from "../../api/masterApi";

export default function AssetSourceLocation() {
  return (
    <MasterCrudPage
      title="Asset Source Location Master"
      description="Define the asset source locations available for assets."
      idKey="asset_source_location_id"
      api={assetSourceLocationApi}
      listLabel="asset source locations"
      useJson
      fields={[
        {
          name: "asset_source_location",
          label: "Asset Source Location",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "Enter asset source location",
        },
      ]}
      columns={[
        { key: "asset_source_location_id", label: "Asset Source Location" },
        { key: "asset_source_location", label: "Asset Source Location" },
      ]}
    />
  );
}
